import * as React from 'react'
import {
  COOKIE_CONSENT_CHANGED_EVENT,
  hasAcceptedAllCookies,
  hasGivenConsent,
  showCookieConsent,
} from '../cookieConsent'

function shouldShow(): boolean {
  return hasGivenConsent() && !hasAcceptedAllCookies()
}

export function CookieReminderBubble() {
  const [visible, setVisible] = React.useState<boolean>(false)

  React.useEffect(() => {
    const update = () => setVisible(shouldShow())
    update()
    window.addEventListener(COOKIE_CONSENT_CHANGED_EVENT, update)
    return () => window.removeEventListener(COOKIE_CONSENT_CHANGED_EVENT, update)
  }, [])

  if (!visible) return null

  return (
    <button
      type="button"
      className="cookie-reminder-bubble"
      onClick={showCookieConsent}
      aria-label="Akceptuj pliki cookie"
      title="Akceptuj pliki cookie"
    >
      <span className="cookie-reminder-bubble__tooltip">Akceptuj cookies?</span>
      <span className="cookie-reminder-bubble__icon" aria-hidden="true">
        🍪
      </span>
    </button>
  )
}
